<template>
	<div class="bind-cus-body">
		<div class="select-box">
			<div class="select-div">
				<div class="name-div">客户名称：</div>
				<el-input class="select-input" v-model="name" size="mini"></el-input>
			</div>
			<div class="select-div">
				<div class="name-div">客户账号：</div>
				<el-input class="select-input" v-model="tel" size="mini"></el-input>
			</div>
			<div class="select-div">
				<div class="name-div">客户类别：</div>
				<el-select v-model="customercategoryid" class="select-input" size='small'>
					<el-option value="" label="全部"></el-option>
					<el-option v-for="item in customerList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="select-div">
				<div class="name-div">客户编号：</div>
				<el-input class="select-input" v-model="code" size="mini"></el-input>
			</div>
			<div class="select-div">
				<div class="name-div">启用状态：</div>
				<el-select v-model="disabledflag" class="select-input" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="select-div" style="width: 150px;margin-left: 50px;">
				<el-button type="primary" size='mini' @click="selectClick">查询</el-button>
				<el-button size='mini' @click="clearClick">清空</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="table-box">
				<div class="select-title">请选择客户</div>
				<el-table
					:stripe='true'
					:data="tableData"
					size='mini'
					height="85%"
					border
					ref="table"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						label="客户名称"
						prop='customername'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户账号"
						prop='tel'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户类别"
						prop='customercategoryname'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户编号"
						prop='customerCode'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="启用状态"
						prop='disabledflag'
						min-width="180"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.disabledflag ? '停用' : '启用'}}</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-box">
					<el-pagination
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="page.page"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
					</el-pagination>
				</div>
			</div>
			<div class="table-box" style="margin-left: 20px;">
				<div class="select-title">已选择客户：{{this.ids.length}}</div>
				<el-table
					:stripe='true'
					:data="ids"
					size='mini'
					height="85%"
					border
					ref="table1"
					@select="handleSelectionChange1"
					@select-all="handleSelectionChange1">
					<el-table-column
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						label="客户名称"
						prop='customername'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户账号"
						prop='tel'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户类别"
						prop='customercategoryname'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="客户编号"
						prop='customerCode'
						min-width="180"
						align="center">
					</el-table-column>
					<el-table-column
						label="启用状态"
						prop='disabledflag'
						min-width="180"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.disabledflag ? '停用' : '启用'}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="binding-foot">
			<el-button size='mini' @click="cancelClick">取消</el-button>
            <el-button size='mini' type="primary"  @click="saveClick">确认</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'addCusModal',
	props: {
		proId: String,
		proName: String
	},
	data () {
		return {
			disabledflag: -1,
			name: '',
			customercategoryid: '',
			tel: '',
			code: '',
			customerList: [],
			page: {
				page: 1,
				size: 20
			},
			tableData: [],
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'syscodeid'
			}),
			total: 0
		}
	},
	created () {
		this.getCustomer()
		this.tableReload()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		clearClick () {
			this.page = {
				page: 1,
				size: 20
			}
			this.disabledflag = -1
			this.name = ''
			this.customercategoryid = ''
			this.tel = ''
			this.code = ''
			this.tableReload()
		},
		selectClick () {
			this.page = {
				page: 1,
				size: 20
			}
			this.tableReload()
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.table1)
			})
		},
		handleSelectionChange1 (data) {
			this.tableSelectUtils.selectToggle(this.ids, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
			})
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveClick () {
			let arr = []
			let list = this.ids
			if (list.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			let text = []
			list.forEach(item => {
				arr.push(item.syscodeid)
				text.push('客户：' + item.customername)
			})
			let params = {
				productid: this.proId,
				syscodeIds: arr
			}
			let changeData = {
				info: `私密商品：${this.proName}”新增绑定”` + text.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/savecustomerbyproduct`,
				data: params,
				logger
			}).then(res => {
				if (res.resultFlag) {
					this.$message.success('保存成功')
					this.$emit('cancel', false)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		tableReload () {
			let params = {
				productid: this.proId,
				name: this.name,
				tel: this.tel,
				customercategoryid: this.customercategoryid,
				code: this.code,
				page: this.page.page,
				size: this.page.size
			}
			if (this.disabledflag !== -1) {
				params.disabledflag = this.disabledflag
			}
			console.log(params)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/unrelcustomer`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = res.recordCount
				if (this.tableData !== null) {
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
					})
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		handleSizeChange (val) {
			this.page.page = 1
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.page = val
			this.tableReload()
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customerList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.bind-cus-body{
	display: flex;
	width: 100%;
	height: 600px;
	flex-direction: column
	position :relative;
}
.select-box{
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.select-div{
	height: 46px
	align-items: center;
	display: flex;
	width: 300px;
	.name-div{
		min-width: 100px;
		text-align: right
	}
	.select-input{
		flex: 1;
	}
}
.table-container{
	display: flex;
	box-sizing: border-box
	height:calc(100% - 150px);
}
.table-box{
	height: 100%;
	width: calc(50% - 10px)
	.page-box{
		margin-top:10px
		text-align :center
	}
}
.select-title{
	line-height: 30px;
	text-align: left
}
.binding-foot{
	position: relative;
	height :40px;
	margin-top:20px;
	margin-bottom :10px;
	width :100%
	.btn{
		width :35%;
		margin-left:30px;
	}
}
</style>
<style lang="stylus">
</style>
